<template>
    <div class="home_kh_box">
        <HeaderNav
            header-title="企业客户端"
            left-icon-name="1"
            right-icon-name="1"
        ></HeaderNav>
        <div class="header-box">
            <img src="@/assets/images/home_sj/bannner.jpg" alt="">
        </div>
        <div class="home-content">
            <template v-for="(item, index) in homeData">
                <div
                    class="item"
                    :class="`color${(index)%4}`"
                    :key="index"
                    @click="routerLink(item.routerName)"
                    v-if="item.routerName"
                >
                    <div class="info">
                        <div class="split-icon">
                            <i></i>
                        </div>
                        <div class="tit">
                            <h4>{{ item.name }}</h4>
                            <p>
                                {{ item.info }}
                            </p>
                        </div>
                    </div>
                    <div class="img-con">
                        <img :src="item.imgUrl">
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import imgUrl0 from './../../assets/images/home_kh/attendance_record.png';
import imgUrl1 from './../../assets/images/home_kh/contract_home.png';
import imgUrl2 from './../../assets/images/home_kh/projetct_home.png';
import imgUrl3 from './../../assets/images/home_kh/materials_home.png';
import imgUrl4 from './../../assets/images/home_kh/vehicle_home.png';
import imgUrl5 from './../../assets/images/home_kh/evaluate_home.png';
import imgUrl6 from './../../assets/images/home_kh/account_home.png';
import imgUrl7 from './../../assets/images/home_kh/statistics_home.png';
import imgUrl8 from './../../assets/images/home_kh/communcation_home.png';
export default {
    data() {
        return {
            homeData: [
                {
                    name: '合同信息',
                    info: '此处为合同信息简单介绍',
                    imgUrl: imgUrl1,
                },
                {
                    name: '工程信息',
                    info: '此处为工程信息简单介绍',
                    imgUrl: imgUrl2,
                },
                {
                    name: '用料申请',
                    info: '此处为用料申请简单介绍',
                    imgUrl: imgUrl0,
                    routerName: 'materialPlan',
                },
                {
                    name: '车辆物流',
                    info: '此处为车辆物流简单介绍',
                    imgUrl: imgUrl4,
                },
                {
                    name: '交付评价',
                    info: '此处为交付评价简单介绍',
                    imgUrl: imgUrl5,
                    routerName: 'transSheet',
                },
                {
                    name: '订单进度',
                    info: '此处为订单进度简单介绍',
                    imgUrl: imgUrl3,
                    routerName: 'orderSituationList',
                },
                {
                    name: '结算对账',
                    info: '此处为结算对账简单介绍',
                    imgUrl: imgUrl6,
                },
                {
                    name: '财务统计',
                    info: '此处为财务统计简单介绍',
                    imgUrl: imgUrl7,
                },
                {
                    name: '沟通反馈',
                    info: '此处为沟通反馈简单介绍',
                    imgUrl: imgUrl8,
                    routerName: 'feedbackList',
                },
                {
                    name: '合同进度',
                    info: '此处为合同进度简单介绍',
                    imgUrl: imgUrl1,
                    routerName: 'contractProgress',
                },
            ],
        };
    },
    components: {
        HeaderNav,
    },
    mounted() {

    },
    methods: {
        routerLink(routerName) {
            this.$router.isBack = 2;
            this.$router.push({ name: routerName });
        },
    },
};

</script>
<style lang='stylus'>
.home_kh_box
    height 100%
    padding-top 44rpx
    .header-box
        width 100%
        height 184rpx
        img
            width 100%
            height 100%
    .home-content
        background #F0F0F0
        overflow hidden
        height calc(100% - 184rpx)
        .item
            width calc(50% - 15rpx);
            height 87rpx;
            background rgba(255,255,255,1)
            box-shadow 0px 2px 8px 0px rgba(0, 0, 0, 0.1)
            float left
            margin 10rpx
            padding 10rpx 0 10rpx 10rpx
            &:nth-child(1n)
                margin-right 0
            .info
                float left
                width calc(100% - 55rpx)
                height 100%
                .split-icon
                    width 3rpx
                    height 100%
                    float left
                    i
                        width 3rpx
                        height 13rpx
                        background #3595FA
                        display inline-block
                        margin-top 9rpx
                .tit
                    width calc(100% - 3rpx)
                    height 100%
                    float left
                    padding-left 10rpx
                    h4
                        font-size 14rpx
                        margin 5rpx 0
                    p
                        font-size 10rpx
                        color #979EA7
            .img-con
                float left
                width 55rpx
                height 55rpx
                img
                    width 100%
                    height 100%
            &.color0
                .split-icon
                    i
                        background #3595FA
            &.color1
                .split-icon
                    i
                        background #F15545
            &.color2
                .split-icon
                    i
                        background #FF6600
            &.color3
                .split-icon
                    i
                        background #16BC84
</style>
